import { type TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";
import type { Dispatch, ReducersMapObject } from "redux";
import commonUtilLogic from "../../../common-deprecated/redux/logic/CommonUtilLogic";
import modalReducer from "../../../common-deprecated/redux/reducers/ModalReducer";
import utilReducer from "../../../common-deprecated/redux/reducers/UtilReducer";
import { getInitStoreByReducers } from "../../../common-deprecated/redux/storeHelpers";
import type { CreateLogicType } from "../../../common-deprecated/redux/typeHelpers";
import type { NewCarCompareActionsType } from "./actions/NewCarCompareActions";
import newCarCompareLogic, { serverNewCarCompareLogic } from "./logic/NewCarCompareLogic";
import newCarCompareReducer, { type NewCarCompareReducerType } from "./reducers/NewCarCompareReducer";
import CompareV2SettingsReducer, { type CompareV2SettingsType } from "./reducers/CompareV2SettingsReducer";
import CommonSettingsReducer from "../../../common-deprecated/redux/reducers/CommonSettingsReducer";
import type { CompareV2SettingsActionsType } from "./actions/CompareV2SettingsActions";
import type { CommonActionsType, CommonReducerType } from "../../../common-deprecated/redux/commonStore";
import newCarCompareExternalDataReducer, {
    type NewCarCompareExternalDataReducerType,
} from "../../../common-deprecated/features/compare/redux/reducers/NewCarCompareExternalDataReducer";

export type CompareV2StateType = CommonReducerType & {
    newCarCompare: NewCarCompareReducerType;
    newCarCompareExternalData: NewCarCompareExternalDataReducerType;
    compareV2Settings: CompareV2SettingsType;
};

export type CompareV2ActionsType = CommonActionsType | NewCarCompareActionsType | CompareV2SettingsActionsType;

export type CompareV2DispatchType = Dispatch<CompareV2ActionsType>;

export type CompareV2LogicType<T extends CompareV2ActionsType> = CreateLogicType<
    T,
    CompareV2StateType,
    CompareV2DispatchType
>;

export const useCompareV2Dispatch = useDispatch<CompareV2DispatchType>;

export const useCompareV2Selector: TypedUseSelectorHook<CompareV2StateType> = useSelector;

export const compareV2Reducers: ReducersMapObject<CompareV2StateType, any> = {
    newCarCompare: newCarCompareReducer,
    newCarCompareExternalData: newCarCompareExternalDataReducer,
    commonSettings: CommonSettingsReducer,
    compareV2Settings: CompareV2SettingsReducer,
    utils: utilReducer,
    modal: modalReducer,
};

export const compareV2ClientStore = getInitStoreByReducers(compareV2Reducers, [
    ...newCarCompareLogic,
    ...commonUtilLogic,
]);
export const compareV2ServerStore = getInitStoreByReducers(compareV2Reducers, [...serverNewCarCompareLogic]);
